import React from 'react'
import { Grid } from '@mui/material'
import TaskManageViewModal from './TaskManageViewModal'
import TaskUpdateModal from './TaskUpdateModal'
import TaskArchiveModal from './TaskArchiveModal'
import TaskEmailNotificationButton from './TaskEmailNotificationButton'
import { Task } from '../../../../redux/task/types'

interface TaskActionsProps {
  taskData: Task
}

const TaskActions: React.FC<TaskActionsProps> = ({ taskData }) => {
  return (
    <Grid container spacing={{ md: 0.5, lg: 1 }} justifyContent='center' alignItems='center' flexWrap='nowrap' data-testid={`task-actions-${taskData.id}`}>
      <Grid data-testid={`task-view-action-${taskData.id}`}>
        <TaskManageViewModal task={taskData} />
      </Grid>
      <Grid data-testid={`task-edit-action-${taskData.id}`}>
        <TaskUpdateModal taskDetails={taskData} />
      </Grid>
      <Grid data-testid={`task-send-email-action-${taskData.id}`}>
        <TaskEmailNotificationButton task={taskData} />
      </Grid>
      <Grid data-testid={`task-archive-action-${taskData.id}`}>
        <TaskArchiveModal id={taskData.id} />
      </Grid>
    </Grid>
  )
}

export default TaskActions
